import './App.css';

import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { BusinessPlanProgressProvider } from './context/BusinessPlanProgressProvider';
import { ThemeProvider } from './context/ThemeProvider';
import AppRouter from './routes';
import { useChunkErrorHandler } from './hooks/useChunkErrorHandler';

function App() {
  // Hook para lidar com erros de chunk loading
  useChunkErrorHandler();

  return (
    <AuthProvider>
      <ThemeProvider>
        <BusinessPlanProgressProvider>
          <AppRouter />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
              },
              error: {
                duration: 5000,
              },
            }}
          />
        </BusinessPlanProgressProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
